// Module-scoped registry, same idiom as useWalkthroughTarget.js's targetRegistry.
// A "tracked save" is any promise passed through trackSave() that hasn't completed.
const pendingSaves = new Set();

/** Tracks a save promise; returns it unchanged so call sites are unaffected. */
export const trackSave = (promise) => {
  pendingSaves.add(promise);
  promise.finally(() => pendingSaves.delete(promise)).catch(() => {});
  return promise;
};

/** Resolves once every tracked save has settled. Never rejects. */
export const waitForPendingSaves = async () => {
  await Promise.allSettled([...pendingSaves]);
};
